
import {
  HIDE_ACTION_SHEET,
  SHOW_ACTION_SHEET
} from '@actions/types'

const initialState = {
  actionSheet: null
}

const reducer = (state = initialState, action) => {
  const { type } = action

  switch (type) {
  case SHOW_ACTION_SHEET:
    return {
      ...state,
      actionSheet: action.payload
    }
  case HIDE_ACTION_SHEET:
    return {
      ...state,
      actionSheet: null
    }
  default:
    return state
  }
}

export default reducer
